<div
  class="data-panel w-full relative overflow-hidden my-[36px] pb-[26px] px-[34px]"
>
  <div class="font-termina mt-[24px] text-[20px] lg:text-[24px]">
    Associated Questionnaires
  </div>
  <div class="h-[1px] w-full bg-inverted-neutral opacity-40 my-[20px]"></div>

  @if (surveyRespondentQuestionnairesPaginated) {
    <div>
      <div
        class="rounded-[10px] border border-textbox-border p-[20px] mb-[36px]"
      >
        <div class="w-full flex flex-col">
          <div
            class="text-left inter-500 text-[14px] flex h-[31px] mb-[14px] text-support-text"
          >
            <div
              (click)="sortResults('questionnaireName')"
              (keydown.enter)="sortResults('questionnaireName')"
              (keydown.space)="sortResults('questionnaireName'); $event.preventDefault()"
              [attr.aria-label]="getSortAriaLabel('Questionnaire', 'questionnaireName')"
              class="w-[400px] pl-[20px] flex items-center cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kek-purple rounded-[4px]"
              role="button"
              tabindex="0"
            >
              <span>Questionnaire</span>
              @if (sortKey === 'questionnaireName') {
                <span class="ml-2">
                  <span
                    [ngClass]="sortDirection === 'asc' ? '' : 'rotate-180'"
                    class="material-symbols-outlined m-auto w-[20px] transition-transform duration-200"
                    aria-hidden="true"
                    >arrow_upward</span
                  >
                </span>
              }
            </div>
            <div
              class="w-[1px] bg-inverted-neutral opacity-40 rounded-full"
            ></div>
            <div
              (click)="sortResults('startedAt')"
              (keydown.enter)="sortResults('startedAt')"
              (keydown.space)="sortResults('startedAt'); $event.preventDefault()"
              [attr.aria-label]="getSortAriaLabel('Start Date', 'startedAt')"
              class="w-[200px] pl-[20px] flex items-center cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kek-purple rounded-[4px]"
              role="button"
              tabindex="0"
            >
              <span>Start Date</span>
              @if (sortKey === 'startedAt') {
                <span class="ml-2">
                  <span
                    [ngClass]="sortDirection === 'asc' ? '' : 'rotate-180'"
                    class="material-symbols-outlined m-auto w-[20px] transition-transform duration-200"
                    aria-hidden="true"
                    >arrow_upward</span
                  >
                </span>
              }
            </div>
            <div
              class="w-[1px] bg-inverted-neutral opacity-40 rounded-full"
            ></div>
            <div
              (click)="sortResults('status')"
              (keydown.enter)="sortResults('status')"
              (keydown.space)="sortResults('status'); $event.preventDefault()"
              [attr.aria-label]="getSortAriaLabel('Status', 'status')"
              class="w-[200px] pl-[20px] flex items-center cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kek-purple rounded-[4px]"
              role="button"
              tabindex="0"
            >
              <span>Status</span>
              @if (sortKey === 'status') {
                <span class="ml-2">
                  <span
                    [ngClass]="sortDirection === 'asc' ? '' : 'rotate-180'"
                    class="material-symbols-outlined m-auto w-[20px] transition-transform duration-200"
                    aria-hidden="true"
                    >arrow_upward</span
                  >
                </span>
              }
            </div>
          </div>
          <div class="h-[1px] bg-inverted-neutral opacity-40 mb-[14px]"></div>
          @for (
            questionnaire of surveyRespondentQuestionnairesPaginated.records;
            track questionnaire
          ) {
            <div
              class="interactive-row inter-300 text-[14px] text-support-text py-[13px] flex"
              (click)="
                showQuestionnaireDetails(
                  questionnaire.questionnaireInstanceGuid
                )
              "
              (keydown.enter)="
                showQuestionnaireDetails(
                  questionnaire.questionnaireInstanceGuid
                )
              "
              (keydown.space)="
                showQuestionnaireDetails(
                  questionnaire.questionnaireInstanceGuid
                );
                $event.preventDefault()
              "
              [attr.aria-label]="'View answers for ' + questionnaire.questionnaireName"
              role="button"
              tabindex="0"
            >
              <div class="w-[400px] pl-[20px] flex items-center break-all">
                <div class="min-w-0">
                  <div>{{ questionnaire.questionnaireName }}</div>
                  @if (questionnaire.parentQuestionnaireName) {
                    <div class="inter-300 text-[12px] text-base-200">
                      Source: {{ questionnaire.parentQuestionnaireName }}
                    </div>
                  }
                </div>
                @if (questionnaire.isTest) {
                  <span
                    class="ml-auto mr-1 rounded-full border border-kek-purple/40 bg-kek-purple/15 px-3 py-1 inter-500 text-[11px] tracking-[0.08em] text-kek-purple"
                  >
                    TEST
                  </span>
                }
              </div>
              <div class="w-[200px] pl-[30px] flex items-center">
                {{ questionnaire.startedAt | date: 'dd/MM/yyyy' }}
              </div>
              <div class="w-[200px] pl-[30px] flex items-center truncate">
                {{ questionnaire.status }}
              </div>
            </div>
          }
        </div>
      </div>
      <div class="flex justify-end">
        <app-paginator
          [pageSize]="surveyRespondentQuestionnairesPaginated.pageSize"
          [pageNumber]="surveyRespondentQuestionnairesPaginated.pageNumber"
          [totalRecords]="surveyRespondentQuestionnairesPaginated.totalRecords"
          (pageChanged)="changePage($event)"
        />
      </div>
    </div>
  }
</div>
